import config from '../../scripts/config.json';
import { setCounters, setIdAirport, setIdUser, setJWT, setMenu, setVersion } from "../pages/commons/functions";
// fetchWithWatch.ts
type FetchWatcher = (url: string, options: RequestInit, response?: Response, error?: any) => void;

let globalWatcher: FetchWatcher | null = null;

export const setGlobalFetchWatcher = (fn: FetchWatcher) => {
  globalWatcher = fn;
};
export const fetchWithWatch = async (url: string, options: RequestInit = {}) => {


  try {
    const currentHash = window.location.hash.split('?')[0] || "#";
    options.headers = {
      ...options.headers,
      "m-routing": currentHash
    };
    const response = await fetch(url, options);
    const clonedResponse = response.clone();
    // Call watcher with the response
    if (globalWatcher) globalWatcher(url, options, response);
    url = url.split("?")[0];
    if (url.endsWith("/routing/v1/")) {
      try {
        const bodyText = await clonedResponse.text();
        let json: any = null;
        try {
          json = JSON.parse(bodyText);
          let dataTmp = json;
          let currentHash = (window.location.hash).replace("#", "") || '';

          if (json && json.code && (json.code == -1 || json.code == -10))

            if (!window.location.hash.startsWith("#user/")) {
              if (dataTmp.codeLogin && dataTmp.codeLogin == -1) {
                console.log("Invalid login, redirect to login");
                setIdUser(0); setIdAirport(0); setJWT("")
                window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
                return;
              }
              else if (dataTmp.code && dataTmp.code == -10) {
                console.log("Invalid JWT, redirect to login");
                setIdUser(0); setIdAirport(0); setJWT("")
                window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
                return;
              } else if (dataTmp.JWT === "") {
                console.log("2B.-No JWT, redirect to login");
                setIdUser(0); setIdAirport(0); setJWT("")
                window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
                return;
              }
            }
          /*
        if (json && json.route && json.routeInvalid && json.routeInvalid === 1) {
          updateGlobalMessages([{
            type: "info",
            header: "Ruta in válida",
            content: `La ruta no esta registrado en su perfil: ${json.route}. Por favor verifique en configuración.`,
            dismissible: false,
            id: "route-valid-info"
          }])
        } else {
          updateGlobalMessages([]);
        }
          */
          if (json.needsInfoUpdate) {
            if (window.location.hash.indexOf("#user/") === -1) {
              window.location.hash = "#user/profile?returnUrl=" + encodeURIComponent(window.location.hash);
            }
          }
          if (json && json.version) {
            setVersion(json.version);
          }
          if (json && json.menu) {
            setMenu(json.menu);
          }
          if (json && json.counters) {
            setCounters(json.counters);
          }
          //serverVersion

          if (json.version) {
            if (json.version !== config.version) {
              setVersion(json.version);
            }
          }


        } catch {
          console.warn("⚠️ Response is not valid JSON:");
        }

      } catch (err) {
        console.warn("⚠️ Could not read cloned response body:", err);
      }
    }
    return response;
  } catch (err) {
    // Also call watcher with error
    if (globalWatcher) globalWatcher(url, options, undefined, err);
    throw err;
  }
};
